import React, { useEffect, useRef, useState, useCallback } from 'react';
import './TopicsScroller.css';

export default function TopicsScroller({ topics, selected, onToggle }) {
  const viewportRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const updateScrollState = useCallback(() => {
    const el = viewportRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 0);
    setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
  }, []);

  useEffect(() => {
    updateScrollState();
    const el = viewportRef.current;
    if (!el) return;
    el.addEventListener('scroll', updateScrollState, { passive: true });
    const ro = new ResizeObserver(updateScrollState);
    ro.observe(el);
    return () => {
      el.removeEventListener('scroll', updateScrollState);
      ro.disconnect();
    };
  }, [updateScrollState]);

  return (
    <div className="topics-scroller">
      <div className="topics-viewport" ref={viewportRef}>
        <div className="topics-track">
          {topics.map((topic) => (
            <button
              key={topic}
              className={`topic-chip ${selected.includes(topic) ? 'active' : ''}`}
              onClick={() => onToggle(topic)}
            >
              {topic}
            </button>
          ))}
        </div>
      </div>
      <div className={`edge-fade left ${canScrollLeft ? 'show' : ''}`} />
      <div className={`edge-fade right ${canScrollRight ? 'show' : ''}`} />
    </div>
  );
}


